import * as React from "react";
import { Card } from "antd";

export const NoPort: React.FC = () => {
  return (
    <div className="cpln-form-section cpln-ant-tab-content">
      <Card>
        <div className="text-lg font-semibold">No Ports</div>
      </Card>
    </div>
  );
};
